import { RenderComponentStrategy } from './render-component.strategy';

export class Beam extends RenderComponentStrategy {
	componentKey = 'Frame';
}
